import { CommonRes } from '@/types';

export const safeApiCall = async <T>(
  fn: () => Promise<CommonRes<T>>,
): Promise<T | null> => {
  try {
    const res = await fn();
    if (res.code === 0) {
      return res.data;
    } else {
      console.warn('API 回傳錯誤:', res.message);
      return null;
    }
  } catch (error) {
    console.error('API 呼叫失敗:', error);
    return null;
  }
};
